import { LiveLikeCheerMeter } from "@livelike/engagementsdk";
import "./cheer-option";
import "./vote-count";
import "./sbs-cheer-meter.css";
const html = (window as any).html;

class CheerMeter extends LiveLikeCheerMeter {
  render() {
    return html`
      <template kind="cheer-meter" id="custom-cheer">
        <livelike-widget-root class="custom-widget">
          <livelike-widget-header class="widget-header" slot="header">
            <livelike-title class="custom-title"></livelike-title>
          </livelike-widget-header>
          <livelike-widget-body>
            <div class="cheer-image-body">
              <sbs-vote-count></sbs-vote-count>
              <livelike-select class="image-grid">
                <template>
                  <livelike-option>
                    <sbs-cheer-option></sbs-cheer-option>
                  </livelike-option>
                </template>
              </livelike-select>
            </div>
          </livelike-widget-body>
        </livelike-widget-root>
      </template>
    `;
  }
}
customElements.define("sbs-cheer-meter", CheerMeter as any);
